import dayjs from "dayjs";

export const fDate = (data: number, format?: string) => {
  if (data) return dayjs(data).format(format || "DD.MM.YYYY");
  return undefined;
};
